import { Component, OnInit } from '@angular/core';
import { LayoutState } from 'app/shared/layout/layout-state';

@Component({
    selector: 'sbw-component-demo',
    templateUrl: './component-demo.component.html',
    styleUrls: ['./component-demo.component.css']
})
export class ComponentDemoComponent implements OnInit {
    constructor(private layout: LayoutState) { }

    ngOnInit() {
        this.layout.setIsContentLoaded(true)
    }
}
